"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.18.79V.74A.74.74,0,1,0,6.7.74v3H2.36L0,6.62,2.36,9.53H6.7v6.91H2.13a.66.66,0,0,0-.65.66.65.65,0,0,0,.65.65H12.75a.65.65,0,0,0,.65-.65.66.66,0,0,0-.65-.66H8.18V13.1h3.4L14,10.19l-2.37-2.9H8.18V6.6h6.15l2.26-2.78V3.56L14.33.79ZM6.7,5v3.2H3L1.68,6.62,3,5Zm1.48.27V2.09h5.53L15,3.69l-1.3,1.6Zm0,6.5V8.6H11l1.3,1.59L11,11.79Z"
  })
}), '0 0 16.59 17.75');